import { Component } from '@angular/core';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { PlansComponent } from './features/plans/plans.component';

/**
 * Root Application Component
 *
 * Shows plans directly (no routing)
 * Plans are always visible - authentication only affects available actions
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LayoutComponent, PlansComponent],
  template: `
    <app-layout>
      <app-plans></app-plans>
    </app-layout>
  `
})
export class AppComponent {
  title = 'memowl-license';
}
